/**
 * 三方授权配置
 */

 // 授权回调域名

const cbHost = 'https://web.upliveapps.com';

// 碰碰在sns平台中信息
// key值为sourceid
const upInfoInSNS = {
    'wechat': {
        appId: 'wxbe95819b0e7499a9',
        appSecret: 'b34144895076ee00a3c2dd5c9bb2f3cb'
    },
    'fb': {
        appId: '1698316857098420'
    },
    'weibo': {
        appid: '3739970591'
    },
    google: {
        clientId: '810710132118-nhlomv7vpqsm6v2a0c9lsgkhbpd4c2qo.apps.googleusercontent.com'
    }
}

export {
	cbHost,
	upInfoInSNS
}



// WEBPACK FOOTER //
// ./js/component/thirdparty-login/config.js